import { render, staticRenderFns } from "./RecruitmentInfo.vue?vue&type=template&id=0fed8c10&scoped=true&"
import script from "./RecruitmentInfo.vue?vue&type=script&lang=js&"
export * from "./RecruitmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./RecruitmentInfo.vue?vue&type=style&index=0&id=0fed8c10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fed8c10",
  null
  
)

export default component.exports